/**
 * Component that includes all public routes in the application
 */
import React from 'react';
import { Route } from 'react-router-dom';

import UserInvitationSignupContainer from 'components/UserInvitationSignup/UserInvitationSignupContainer';
import AwsSignupPageContainer from 'components/AwsSignupPage/AwsSignupPageContainer';
import LoginPageContainer from '../../../LoginPage/LoginPageContainer';
import LogoutPageContainer from '../../../LogoutPage/LogoutPageContainer';
import AboutPage from '../../../AboutPage/AboutPage';
import UpdateSessionContainer from '../../../UpdateSessionPage/UpdateSessionPageContainer';
import SessionLoaderPageContainer from '../../../SessionLoaderPage/SessionLoaderPageContainer';
import OrganizationPageContainer from '../../../OrganizationPage/OrganizationPageContainer';
import ErrorPageContainer from '../../../ErrorPage/ErrorPageContainer';
import LoginRaxSsoPage from '../../../LoginRaxSsoPage/LoginRaxSsoPageContainer';

function PublicRoutes() {
  return [
    <Route exact key="login" path="/login" component={LoginPageContainer} />,
    <Route exact key="raxsso" path="/raxsso" component={LoginRaxSsoPage} />,
    <Route exact key="logout" path="/logout" component={LogoutPageContainer} />,
    <Route exact key="updatesession" path="/updatesession" component={UpdateSessionContainer} />,
    <Route
      exact
      path="/session-callback"
      key="sessionCallback"
      component={SessionLoaderPageContainer}
    />,
    <Route exact path="/about" component={AboutPage} key="about" />,
    <Route exact key="organization" path="/organization" component={OrganizationPageContainer} />,
    <Route
      exact
      key="userInvitation"
      path="/accept-invite/"
      component={UserInvitationSignupContainer}
    />,
    <Route exact key="awsSignup" path="/awssignup" component={AwsSignupPageContainer} />,
    <Route exact key="error" path="/error/:statusCode" component={ErrorPageContainer} />,
    <Route
      exact
      key="error"
      path="/error"
      render={() => <ErrorPageContainer match={{ params: { statusCode: '404' } }} />}
    />,
  ];
}

export default PublicRoutes;
